import { render } from "./PageHeader.vue?vue&type=template&id=59cfb0fc&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=59cfb0fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cfb0fc"]])

export default __exports__